import { createStandaloneToast } from '@chakra-ui/react';
import { parseUserWarnings } from '@common/utils/user-warnings.schema';
import { captureMessage } from '@sentry/react';

const { toast } = createStandaloneToast();

/** Shows server warnings once while their toast is visible, without failing the operation. */
export function showUserWarnings(value: unknown): void {
  const { messages, invalidCount } = parseUserWarnings(value);
  if (invalidCount > 0) {
    captureMessage('Dropped invalid GraphQL warning messages', {
      level: 'warning',
      extra: { invalidCount },
    });
  }
  for (const message of messages) {
    const id = `user-warning:${message}`;
    if (!toast.isActive(id)) {
      toast({
        id,
        status: 'warning',
        description: message,
        duration: 5000,
        isClosable: true,
      });
    }
  }
}
